import React from 'react'
import { SVGProps, Svg } from '..'

export const GermanyFlagIcon: React.FC<SVGProps> = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_104_243)">
    <g clipPath="url(#clip1_104_243)">
    <rect x="1" y="4" width="22" height="16" rx="2" fill="#F93939"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M1 15H24V20H1V15Z" fill="#FFDA2C"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M1 4H24V9H1V4Z" fill="#151515"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_104_243">
    <rect width="22" height="16" fill="white" transform="translate(1 4)"/>
    </clipPath>
    <clipPath id="clip1_104_243">
    <rect x="1" y="4" width="22" height="16" rx="2" fill="white"/>
    </clipPath>
    </defs>
  </Svg>
);

  